import React from 'react';
import { Box, Stack, Paper, Typography } from '@mui/material';
import { DescriptionOutlined as ResolutionIcon } from '@mui/icons-material';
import { StatusEdit, ResolutionDescriptionEdit, ResolutionCategorySelect } from '../fields';

/**
 * ResolutionSection - Component for managing ticket resolution and status
 * Contains ticket status, resolution category, and resolution description
 * All changes save automatically when Save Ticket button is clicked
 */
const ResolutionSection: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={0} sx={{ p: 3, backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 1.5 }}>
        {/* Section Header */}
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 3 }}>
          <ResolutionIcon sx={{ color: '#3b82f6', fontSize: 24 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
            Resolution & Status
          </Typography>
        </Stack>

        {/* Status Field */}
        <Box sx={{ mb: 2 }}>
          <StatusEdit />
        </Box>

        {/* Resolution Category Field */}
        <Box sx={{ mb: 2 }}>
          <ResolutionCategorySelect />
        </Box>

        {/* Resolution Description Field */}
        <ResolutionDescriptionEdit />
      </Paper>
    </Box>
  );
};

export default ResolutionSection;
